import dateFnsGenerateConfig from 'rc-picker/lib/generate/dateFns';
import generatePicker from 'antd/es/date-picker/generatePicker';

// Used to replace momentjs from ant DatePicker
export const DatePicker = generatePicker<Date>(dateFnsGenerateConfig);
